import { Address, getAddress } from "viem";
import { arbitrum, mainnet } from "viem/chains";

import { ERC20Metadata } from "./index";

const placeholder = {} as ERC20Metadata;

/* --- PYUSD --- */

export const PYUSD_TOKEN_ARB: ERC20Metadata = {
  symbol: "PYUSD",
  chainId: arbitrum.id,
  name: "PYUSD",
  address: "0x46850ad61c2b7d64d08c9c754f45254596696984",
  decimals: 6,
  logo: "/svg/erc20/pyusd.svg",
  OftAdapter: "0xfab5891ed867a1195303251912013b92c4fc3a1d",
  peerToken: placeholder,
  mainToken: placeholder,
};

export const PYUSD_TOKEN_ETH: ERC20Metadata = {
  address: "0x6c3ea9036406852006290770bedfcaba0e23a0e8",
  chainId: mainnet.id,
  decimals: 6,
  name: "PYUSD",
  symbol: "PYUSD",
  logo: "/svg/erc20/pyusd.svg",
  OftAdapter: "0xa2c323fe5a74adffad2bf3e007e36bb029606444",
  peerToken: placeholder,
  mainToken: placeholder,
};

PYUSD_TOKEN_ARB.peerToken = PYUSD_TOKEN_ETH;
PYUSD_TOKEN_ETH.peerToken = PYUSD_TOKEN_ARB;
PYUSD_TOKEN_ARB.mainToken = PYUSD_TOKEN_ETH.mainToken = PYUSD_TOKEN_ARB;

export const PYUSD_TOKENS: Record<number, ERC20Metadata> = {
  [arbitrum.id]: PYUSD_TOKEN_ARB,
  [mainnet.id]: PYUSD_TOKEN_ETH,
};

/* --- USDai --- */

export const USDAI_TOKEN_ARB: ERC20Metadata = {
  symbol: "USDai",
  chainId: arbitrum.id,
  name: "USDai",
  address: "0x0a1a1a107e45b7ced86833863f482bc5f4ed82ef",
  decimals: 18,
  logo: "/svg/erc20/usdai.svg",
  OftAdapter: "0xffa10065ce1d1c42fabc46e06b84ed8ffeb4bae5",
  peerToken: placeholder,
  mainToken: placeholder,
};

export const USDAI_TOKEN_ETH: ERC20Metadata = {
  address: "0x0a1a1a107e45b7ced86833863f482bc5f4ed82ef",
  chainId: mainnet.id,
  decimals: 18,
  symbol: "USDai",
  name: "USDai",
  logo: "/svg/erc20/usdai.svg",
  OftAdapter: "0xffa10065ce1d1c42fabc46e06b84ed8ffeb4bae5",
  peerToken: placeholder,
  mainToken: placeholder,
};

USDAI_TOKEN_ARB.peerToken = USDAI_TOKEN_ETH;
USDAI_TOKEN_ETH.peerToken = USDAI_TOKEN_ARB;
USDAI_TOKEN_ARB.mainToken = USDAI_TOKEN_ETH.mainToken = USDAI_TOKEN_ARB;

export const PYUSD_BY_CHAIN: Record<number, ERC20Metadata> = {
  [arbitrum.id]: PYUSD_TOKEN_ARB,
  [mainnet.id]: PYUSD_TOKEN_ETH,
};

/* --- Derived lookups --- */

export const MAINNET_ALL_TOKENS: ERC20Metadata[] = [
  PYUSD_TOKEN_ARB,
  PYUSD_TOKEN_ETH,
  USDAI_TOKEN_ARB,
  USDAI_TOKEN_ETH,
];

export const MAINNET_TOKENS_ADAPTERS: Record<Address, Address> = Object.fromEntries(
  MAINNET_ALL_TOKENS.flatMap((t) => [
    [getAddress(t.address), t.OftAdapter],
    [t.address.toLowerCase(), t.OftAdapter],
  ]),
);

export const MAINNET_TOKENS_PEER: Record<Address, Address> = Object.fromEntries(
  MAINNET_ALL_TOKENS.flatMap((t) => [
    [getAddress(t.address), t.peerToken.address],
    [t.address.toLowerCase(), t.peerToken.address],
  ]),
);
